import { gql } from '@apollo/client';

export const UPSERT_ECD_REGISTRATIONS = gql`
  mutation upsertEcdRegistrations($inputs: UpsertECDRegistrationsInput!) {
    ecdRegistration: upsertEcdRegistrations(inputs: $inputs) {
      id
    }
  }
`;
